/* eslint-disable */
import React from "react";
import { ThemeProvider, makeStyles } from "@material-ui/styles";
import Snackbar from "@material-ui/core/Snackbar";
import theme from "../../../../Themes/defaultTheme";
import MuiAlert from "@material-ui/lab/Alert";
import { Grow } from "@material-ui/core";

const GrowTransition = (props) => {
  return <Grow {...props} />;
};

const useStyles = makeStyles((theme) => ({
  alert: {
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    fontWeight: 500,
    "&.MuiAlert-filledSuccess": {
      backgroundColor: "var(--color-primary-main) !important",
      color: "var(--color-primary-contrast) !important",
    },
    "&.MuiAlert-filledError": {
      backgroundColor: "var(--error-color) !important",
      color: "#ffffff !important",
    },
    "&.MuiAlert-filledWarning": {
      backgroundColor: "#f59e0b !important",
      color: "#ffffff !important",
    },
    "&.MuiAlert-filledInfo": {
      backgroundColor: "var(--color-secondary-main) !important",
      color: "var(--color-secondary-contrast) !important",
    },
  },
}));

const A_Snackbar = (props) => {
  const classes = useStyles();
  const Alert = React.forwardRef((props, ref) => (
    <MuiAlert
      elevation={6}
      variant="filled"
      className={classes.alert}
      {...props}
      ref={ref}
    />
  ));

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        anchorOrigin={{
          vertical: props.vertical,
          horizontal: props.horizontal,
        }}
        open={props.open}
        autoHideDuration={props.autoHideDuration}
        onClose={props.handleClose}
        severity={props.type}
        message={props.message}
        TransitionComponent={GrowTransition}
        action={<React.Fragment>{props.action}</React.Fragment>}
      >
        <Alert onClose={props.handleClose} severity={props.type}>
          {
            props?.isHtml ? (
              <span dangerouslySetInnerHTML={{ __html: props.message }} />
            ) : (
              props.message
            )
          }
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};
A_Snackbar.defaultProps = {
  open: false,
  autoHideDuration: 5000,
  message: "Placeholder for message",
  vertical: "bottom",
  horizontal: "right",
  type: "success",
};
export default A_Snackbar;
